export default "__VITE_ASSET__Cirz4LP7__"